<template>
    <modal class="modal" :close="close" :printStyle="printStyle" :title="title" printButton downloadButton>
        <!-- <h3 slot="modalHeader" class="modal__header">
            <i class="uk-icon-credit-card"></i> Решения о приостановлении операций по счетам налогоплательщика.
        </h3> -->
        <h3 slot="modalHeader" class="modal__header">
            <i class="uk-icon-credit-card"></i>  Решения о блокировке расчётных счетов.
        </h3>

        <div class="modal__content" slot="modalBody" ref="htmlContent">
            <block-invoices-table 
                class="show-on-print" 
                :list="actualList" 
                :actualDate="actualDate" 
                inModal 
            />
            <block-invoices-table 
                :class="{'show-on-print': archiveList.length}" 
                v-show="archiveList.length" 
                :list="archiveList" 
                :actualDate="actualDate" 
                inModal 
                archived 
            />
            <block-invoices-history 
                :class="{'show-on-print': historyList.length}" 
                v-show="historyList.length" 
                :list="historyList" 
                inModal 
            />
        </div>
    </modal>
</template>

<script>
import modal from '@/components/ui/modal.vue'
import blockInvoicesTable from '@/components/card/blockInvoices/blockInvoicesTable.vue'
import blockInvoicesHistory from '@/components/card/blockInvoices/blockInvoicesHistory.vue'

export default {    
    components: {
        modal,
        blockInvoicesTable,
        blockInvoicesHistory
    },
    props: {
        actualDate: String,
        title: String,
        printStyle: String,
        actualList: {
            type: Array,
            default: []
        },
        archiveList: {
            type: Array,
            default: []
        },
        historyList: {
            type: Array,
            default: []
        }
    },
    methods: {
        close() { this.$emit('close') }
    }
}
</script>

<style lang="sass" scoped>
@import 'styles/global-variables'

.modal
    &__header
        font-family: Arial,Tahoma,sans-serif
        font-weight: 100
        font-size: 24px
        color: #444
        font-size: 24px
        text-transform: none
    &__content
        @include column(15px)
        padding: 20px

</style>